import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface DarkModeToggleProps {
  className?: string;
  showLabel?: boolean;
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ 
  className = '', 
  showLabel = false 
}) => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <div className={`dark-mode-toggle ${className}`} style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '0.5rem' 
    }}>
      {showLabel && (
        <span style={{ 
          fontSize: '0.875rem',
          color: 'var(--text-secondary)'
        }}>
          🌙 Dark Mode
        </span>
      )}
      
      <label style={{ 
        position: 'relative',
        display: 'inline-block',
        width: '50px',
        height: '24px',
        cursor: 'pointer'
      }}>
        <input
          type="checkbox"
          checked={isDarkMode}
          onChange={toggleDarkMode}
          style={{ opacity: 0, width: 0, height: 0 }}
        />
        <span style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: isDarkMode ? '#007acc' : '#ccc',
          borderRadius: '24px',
          transition: '0.3s ease',
          cursor: 'pointer'
        }}>
          <span style={{
            position: 'absolute',
            content: '',
            height: '18px',
            width: '18px',
            left: isDarkMode ? '26px' : '3px',
            bottom: '3px',
            backgroundColor: 'white',
            borderRadius: '50%',
            transition: '0.3s ease'
          }}></span>
        </span>
      </label>
    </div>
  );
};

export default DarkModeToggle;